import contextArticleTextbox from '@contexts/articleTextbox'
import useHeightTransition from '@hooks/useHeightTransition'
import {
  FunctionComponent,
  ReactNode,
  useCallback,
  useContext,
  useEffect,
} from 'react'
import styled, { css } from 'styled-components'

const { ArticleTextboxContext } = contextArticleTextbox

const StyledContentWrapper = styled.div`
  ${({
    theme: {
      colors: {
        grey: { grey_20 },
      },
    },
  }) => css`
    border-left: 4px solid ${grey_20};
    padding: 0 20px 0px 20px;
    overflow: hidden;
    transition: height 0.5s ease-out;
  `}
`

const ExpandableContentWrapper: FunctionComponent<{ children?: ReactNode }> = ({
  children,
}) => {
  const { isExpanded } = useContext(ArticleTextboxContext)

  const getIsVisible = useCallback(() => isExpanded, [isExpanded])
  const { setComponentRef, setNodeHeight } = useHeightTransition({
    getIsVisible,
    collapsedHeight: 115,
  })

  useEffect(() => {
    setNodeHeight(isExpanded)
  }, [setNodeHeight, isExpanded])

  return (
    <StyledContentWrapper ref={setComponentRef}>
      {children}
    </StyledContentWrapper>
  )
}

export default ExpandableContentWrapper
